import { Fragment, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom';

import { SET_UNAME } from '../../redux/reducers/site';
import API from '../API/api';

export default function EditableInput(props){
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [content, setContent] = useState(props.content);
    const setup = useSelector(state => state.site.setup);

    const handleKeyPress = evt =>{if (evt.key === 'Enter') { evt.target.blur(); }}
    const [warn, setWarn] = useState('ok');

    // Явно проверяем, что язык валиден, иначе используем 'ru' по умолчанию
    let LANG = ['ru', 'en', 'de'].includes(setup.lang) ? setup.lang : 'ru';

    if(localStorage.user){
        var user = JSON.parse(localStorage.getItem("user"));
    } else {
        navigate(`/${LANG}/login`, { replace: true });
        return null;
    }

    return (
        <Fragment>
            {
            props.inactive?
            <div className='edit inactive'>
                {content}
            </div>
            :
            <Fragment>
            <div contentEditable="true" className={props.inline?'inline':null}
                onInput={(ev)=>handleChange(ev)} 
                onBlur = {(ev)=>onBlurHandle(ev)}
                onKeyDown = {(ev)=>handleKeyPress(ev)}>
            {content}
            </div>
            { warn !=='ok' ? <p className='warn'>{warn}</p> : null}
            </Fragment>
            }
        </Fragment>
    )

function handleChange(ev){
    //console.log(ev.target.innerHTML);
}

function onBlurHandle(evt){
    let cont = sanitize(evt.target.innerText);

    if(content !== cont){
        setContent(cont);
        if(localStorage.uloged) SaveData(cont);
        }
}

function sanitize(html) {
    var doc = document.createElement('div');
    doc.innerHTML = html;
    return doc.innerHTML;
}

function SaveData(cont){
  
    const form = new FormData()
            form.append('lang', LANG);
            form.append('value', cont);
            form.append('tag', props.tag);
            form.append('user', user.usr);
            if(props.tid){
                form.append('id', props.tid);
            } else {
                form.append('id', 'none');
            }
  
    API.postFormData('editableup', form)
      .then(data => {
          let msg = data.resp;
          if(msg ==='ok'){ 
            setWarn('ok'); 
            user[props.tag] = cont;
            localStorage.setItem('user', JSON.stringify(user));
            dispatch(SET_UNAME(user.fio));
            } else
                    { setWarn(msg); }
      
        })
      .catch(error => {
          //setAllIs({...AllIs, error:error});
      });
  }
}